import { watchSteps } from "@/mocks/home";

export default function WatchGuide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-10 max-w-3xl">
          <span className="font-label text-xs tracking-widest text-primary-600">GUIDE</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            观看指南：四步开始在线播放
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            如果你是第一次浏览这类页面，按下面的顺序走一遍，基本不会卡住。整个过程都不需要额外注册或提交任何信息。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {watchSteps.map((step) => (
            <div
              key={step.step}
              className="group relative flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-6 transition-colors hover:border-primary-300"
            >
              <span className="font-heading text-3xl font-bold text-background-300 transition-colors group-hover:text-primary-300">
                {step.step}
              </span>
              <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                <i className={step.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}